module.exports = __webpack_public_path__ + "img/Logo_Ministerstwo.224fefc4.webp";